import { Box, Chip } from '@mui/material'
import React, { Fragment } from 'react'

export { RequiredMark } from './RequiredMark'

export const renderOrigins = (namesOrderOrigin: any) => {
  if (!namesOrderOrigin || namesOrderOrigin.length === 0)
    return 'Sin configurar'

  const visibleItems = namesOrderOrigin.slice(0, 3)
  const masItems = namesOrderOrigin.length > 3

  return (
    <Fragment>
      {visibleItems.map((item: string, index: number) => (
        <Chip
          key={`${item}-${index}`}
          label={item === '' ? 'Sin Nombre' : item}
        />
      ))}

      {masItems && <Chip label='...' />}
    </Fragment>
  )
}

export const renderAllRelations = (
  values: string[],
  justifyContent: 'flex-start' | 'center' | 'flex-end' = 'flex-start'
) => {
  if (values.length === 0) return 'Sin configurar'

  return (
    <Box display='flex' flexWrap='wrap' justifyContent={justifyContent} gap={0.5}>
      {values.map((value, index) => (
        <Chip key={index} label={value} />
      ))}
    </Box>
  )
}
